
import get from 'lodash/get';
import LegacyModalCloseButton from './LegacyModalCloseButton.vue';

export default {
  components: {
    LegacyModalCloseButton,
  },
  emits: ['click-close'],
  props: {
    mediaURL: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    mediaStyle() {
      return {
        backgroundImage: `url(${this.mediaURL})`,
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit('click-close');
    },
    handleModalClick(event) {
      const targetClasses = get(event, 'target.className', '');

      if (targetClasses.includes('handle-outside-modal-click')) {
        this.closeModal();
      }
    },
    handleModalKeyDown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.closeModal();
      }
    },
  },
};
